import { useModalUserProfile } from "providers/UserProfileProvider";
import { useEffect, useState } from "react";
import { TopicDialog } from "views/foundation/topic/dialogs/TopicDialog";
import { ChannelDialog } from "views/knowledge/channels/dialogs/ChannelDialog";
import { PublicationViewerDialog } from "views/knowledge/publication/dialogs/PublicationViewerDialog";
import { TrainingInfoDialog } from "views/lms/dialogs/TrainingInfoDialog";

export const useMentionInterceptor = (elementId: string) => {
    const { showUser } = useModalUserProfile();
    const [dialog, setDialog] = useState<any>(null);

    const handleClick = (el: MouseEvent) => {
        const target = el.target as HTMLElement;
        if (target.tagName == "A") {
            if (target.className.includes("ql-mention-link") || target.className.includes("ql-performa-link")) {
                el.preventDefault();

                var p = target.closest(".mention");
                var pid = p?.getAttribute("data-id");
                var pot = p?.getAttribute("data-ot");

                const id = target.getAttribute("data-id") ?? pid!;
                const ot = target.getAttribute("data-ot") ?? pot!;

                if (ot == "user") {
                    showUser(id);
                }
                else if (ot == "topic") {
                    setDialog(<TopicDialog
                        topicId={id}
                        onClose={() => setDialog(null)}
                    />);
                }
                else if (ot == "channel") {
                    setDialog(<ChannelDialog
                        channelId={id}
                        onClose={() => setDialog(null)}
                    />);
                }
                else if (ot == "pub") {
                    setDialog(
                        <PublicationViewerDialog
                            publicationId={id!}
                            onClose={() => setDialog(null)}
                        />
                    );
                }
                else if (ot == "training") {
                    setDialog(
                        <TrainingInfoDialog
                            trainingId={id!}
                            onClose={() => setDialog(null)}
                        />
                    );
                }
            }
        }
    };

    useEffect(() => {
        var el = document.getElementById(elementId);
        if (el == undefined)
            console.error(`useMentionInterceptor: "${elementId}" not found.`);
        else
            el.addEventListener("click", handleClick);

        return () => {
            if (el) el.removeEventListener("click", handleClick);
        };
    }, []);

    return [dialog];
};
